import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { resetCookieConsent } from '../CookieConsent/CookieConsent';
import './Footer.css';

const Footer = () => {
  const { lang, t } = useLanguage();

  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Sentmo. {t.footer.copyright}</p>

      <div className="footer-links">
        <NavLink to={`/${lang}/imprint`}>{t.footer.imprint}</NavLink>
        <NavLink to={`/${lang}/dataprotection`}>{t.footer.privacy}</NavLink>
        <button onClick={resetCookieConsent} className="footer-cookie-btn">
          {t.footer.cookieSettings}
        </button>
      </div>
    </footer>
  );
};

export default Footer;
